var GN={
  ww:function(){ var v=(window.innerWidth)?window.innerWidth:$(window).width(); return v; },
  wh:function(){ var v=(window.innerHeight)?window.innerHeight:$(window).height(); return v; },
  dh:function(){
    var v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st:function(){ var v=$(window).scrollTop(); return v; },
  hh:function(){ var v=$('#header').innerHeight(); return v; },
  picsel:function(num){ var v=Math.floor((num*GN.ww())/750); return v; },
  c_picsel:function(a,b,c){ var v=Math.floor((a*c)/b); return v; },
  ua:navigator.userAgent
};

// ユーザーエージェントまたはウィンドウサイズからデバイスを判別
var is_mobile=function(){ var v=(GN.ww()<=749)?true:false; return v; };
var is_desktop=function(){ var v=(GN.ww()>=750)?true:false; return v; };
var is_touch=function(){ var v=(GN.ua.indexOf('iPhone')>1||GN.ua.indexOf('iPad')>1||GN.ua.indexOf('Android')>1)?true:false; return v; };

jQuery(function($){

  $.fn.extend({
    // ウィンドウ幅可変によるサイズ調整
    winSizeSet:function(options){
      var defaults={
        set:new Function
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      $(window).on({ 'resize':function(){ op.set($t); } });
      $t.ready(function(){ op.set($t); });
    },
    // select要素のリンク
    selectLink:function(options){
      var defaults={
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var selected_value=$t.find('option:selected').val();
      $t.off('change');
      $t.on('change',function(){
        var v=$t.val();
        if(v&&v!=selected_value) location.href=v;
      });
    },
    // アナウンス
    announcementBlock:function(options){
      var defaults={
        prefix:'announcement-block',
        cookie:{
          name:'ss-announcement',
          expires:1/24
        },
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $block_message=$t.find('.'+op.prefix+'-message');
      var setAnnouncementCountClass=function(){
        var count=$t.find('.'+op.prefix+'-message:visible').length;
        if(count>2) count=2;
        $('html')
          .removeClass('ss-announcement-count-0 ss-announcement-count-1 ss-announcement-count-2')
          .addClass('ss-announcement-count-'+count);
      };
      
      $block_message.each(function(){
        var $message=$(this);
        var $close=$message.find('.'+op.prefix+'-message--close');
        var id=$message.data('id');
        // Cookie を使わず、毎回表示する
        $message.show();

        $close.off('click');
        $close.on('click', function(){
          $message.fadeOut(op.speed,function(){
            setAnnouncementCountClass();
          });
          // 以前はここで cookie をセットしていたが、常に表示させたいので廃止
          return false;
        });
      });
      setAnnouncementCountClass();
    },
    // ヘッダー
    header:function(options){
      var defaults={
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $through=$('.hd-through');
      var setColor=function(){
        if($through.length){
          var st=GN.st();
          var hd_h=$t.innerHeight();
          var len=$through.length;
          for(var i=0;i<len;i++){
            var $target=$through.eq(i);
            var target_top=$target.offset().top;
            var target_h=$target.innerHeight();
            var color=$target.data('hd-color');
            if(st+hd_h>target_top&&st+hd_h<target_top+target_h){
              $t.addClass('hd-c-'+color);
            }else{
              $t.removeClass('hd-c-'+color);
            };
          };
        };
      };
      setColor();
      $(window).on({
        'load resize scroll':function(){
          setColor();
        }
      });
    },
    // ディゾルブ
    styleDissolve:function(options){
      var defaults={
        prefix:'',
        speed:800,
        interval:4000
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $move=$t.find('.'+op.prefix+'-move');
      var $item=$move.find('.'+op.prefix+'-item');
      var len=$item.length;
      var index=0;
      var bool=true;
      var first=true;
      var touch={
        X:0,
        move:0,
        pos:0,
        bool:false
      };
      var dissolveEvent=function(){
        $move.find('.active').stop().fadeOut(op.speed,function(){
          $(this).removeClass('active');
        })
        $item.eq(index).fadeIn(op.speed,function(){
          bool=true;
          dissolveAuto();
        }).addClass('active');
      };
      var dissolveAuto;
      var dissolveInterval;
      dissolveAuto=function(){
        if(op.interval){
          dissolveInterval=setTimeout(function(){
            if(bool){
              bool=false;
              index=(index==len-1)?0:index+1;
              clearTimeout(dissolveInterval);
              dissolveEvent();
            };
          },op.interval);
        };
      };
      var resetDissolve=function(){
        clearTimeout(dissolveInterval);
        if(len>1){
          setTimeout(function(){ dissolveAuto(); },op.interval);
        };
      };
      var start=function(){
        if(first){
          first=false;
          if(len>1){
            setTimeout(function(){
              $item.eq(index).fadeIn(op.speed).addClass('active');
              resetDissolve();
            },200);
            $move.on({
              'touchstart':function(event){
                touch.bool=true;
                touch.X=event.touches[0].pageX;
              },
              'touchmove':function(event){
                if(Math.abs(touch.X-event.touches[0].pageX)>5&&touch.bool){
                  if(event.cancelable) event.preventDefault();
                  touch.pos=Math.floor(event.touches[0].pageX);
                }else{
                  touch.bool=false;
                };
              },
              'touchend':function(event){
                if(bool&&touch.bool){
                  bool=false;
                  if(touch.X*touch.pos>1){
                    index=(index==len-1)?0:index+1;
                  }else if(touch.X*touch.pos<-1){
                    index=(index==0)?len-1:index-1;
                  };
                  clearTimeout(dissolveInterval);
                  dissolveEvent();
                };
              }
            });
          }else{
            setTimeout(function(){
              $item.eq(index).fadeIn(op.speed).addClass('active');
              resetDissolve();
            },200);
          };
          for(var i=0;i<len;i++){
            $item.eq(i).addClass('origin');
          };
        };
      };

      if($item.eq(len-1).find('img').length){
        $item.eq(len-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };
    },
    // 商品詳細
    productDetail:function(options){
      var defaults={
        prefix:'product-detail',
        speed:0.4,
        interval:0
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $gallery=$t.find('.'+op.prefix+'-gallery');
      var $gallery_frame=$gallery.find('.'+op.prefix+'-gallery__frame');
      var $gallery_move=$gallery.find('.'+op.prefix+'-gallery__move');
      var $gallery_item=$gallery_move.find('.'+op.prefix+'-gallery--item');
      var $description=$t.find('.'+op.prefix+'-description');
      var $description_btn=$description.find('.'+op.prefix+'-description--btn');
      var $description_target=$description.find('.product__description');
      var $description_close=$description.find('.product__description--close');
      var $content=$t.find('.'+op.prefix+'-content');
      var len=$gallery_item.length;
      var len2=len;
      var mobileLoopBuffer=6;
      var mobileLoopBase=function(){ return len*mobileLoopBuffer; };
      var mobileLoopSafeMin=function(){ return len*2; };
      var mobileLoopSafeMax=function(){ return len*(mobileLoopBuffer*2-1); };
      var mobileLoopCenterIndex=function(raw){ return mobileLoopBase()+(((raw%len)+len)%len); };
      var index=mobileLoopBase();
      var gallery_w=function(){ var v=$gallery_frame.width(); return Math.round(v); };
      var bool=true;
      var first=true;
      var touch={
        X:0,
        Y:0,
        now:0,
        move:0,
        pos:0,
        bool:false,
        dragging:false,
        mode:null,
        pointer:false,
        left:function(){ var v=new WebKitCSSMatrix($gallery_move.css('transform')); return Math.floor(v.e); }
      };
      var thumbControl=function(){};
      var initialize=function(){
        clearTimeout(slideInterval);
        stopMobileInertia();
        if(is_mobile()){
          if(!$gallery.data('ssMobileNativeReady') || index<mobileLoopBase() || index>=mobileLoopBase()+len) index=mobileLoopBase();
          var w=gallery_w();
          var gallery_move_w=w*len2;
          $gallery_frame.css({ overflowX:'auto', overflowY:'hidden', WebkitOverflowScrolling:'touch', scrollSnapType:'x mandatory' });
          $gallery_item.show().width(w).css({ flex:'0 0 '+w+'px', scrollSnapAlign:'start' });
          $gallery_move.width(gallery_move_w).css({ display:'flex', transitionTimingFunction:'none',transition:'none',transform:'none' });
          if($gallery_frame[0]){
            var nativeStart=w*index;
            $gallery_frame[0].scrollLeft=nativeStart;
            requestAnimationFrame(function(){ if(is_mobile()&&$gallery_frame[0]) $gallery_frame[0].scrollLeft=nativeStart; });
            setTimeout(function(){ if(is_mobile()&&$gallery_frame[0]) $gallery_frame[0].scrollLeft=nativeStart; },120);
            setTimeout(function(){ if(is_mobile()&&$gallery_frame[0]) $gallery_frame[0].scrollLeft=nativeStart; },420);
          }
          $gallery.data('ssMobileNativeReady',true);
          mobileInertia.currentX=-(w*index);
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
        }else{
          $gallery_frame.css({ overflowX:'', overflowY:'', WebkitOverflowScrolling:'', scrollSnapType:'' });
          $gallery_move.width('').css({ display:'',transition:'',transform:'' });
          $gallery_item.hide().width('').css({ flex:'', scrollSnapAlign:'' });
          $gallery_move.find('.'+op.prefix+'-gallery--item.origin').show();
        };
        slideAuto();
      };
      var slideEvent=function(){
        $gallery_move.css({ transitionTimingFunction:'ease-out',transition:op.speed+'s',transform:'translate3d(-'+(gallery_w()*index)+'px,0,0)' });
        setTimeout(function(){
          if(index==len-1){
            index=len*2-1;
          }else if(index==len*2){
            index=len;
          };
          $gallery_move.css({ transitionTimingFunction:'none',transition:'none',transform:'translate3d(-'+(gallery_w()*index)+'px,0,0)' });
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
          bool=true;
          thumbControl();
          slideAuto();
        },op.speed*1000);
      };
      var slideAuto;
      var slideInterval;
      slideAuto=function(){
        if(op.interval){
          slideInterval=setTimeout(function(){
            if(bool){
              bool=false;
              index=index+1;
              clearTimeout(slideInterval);
              slideEvent();
            };
          },op.interval);
        };
      };
      var resetSlide=function(){
        clearTimeout(slideInterval);
        $gallery_move.css({ transitionTimingFunction:'none',transition:'none' });
        if(len>1){
          setTimeout(function(){ slideAuto(); },op.interval);
        };
        initialize();
      };
      var mobileSwipeHintTimer=null;
      var mobileSwipeHintRaf=null;
      var stopMobileSwipeHint=function(){
        clearTimeout(mobileSwipeHintTimer);
        mobileSwipeHintTimer=null;
        if(mobileSwipeHintRaf){
          cancelAnimationFrame(mobileSwipeHintRaf);
          mobileSwipeHintRaf=null;
        }
      };
      var animateMobileFrameScroll=function(from,to,duration,done){
        var startTime=performance.now();
        var ease=function(t){ return 1-Math.pow(1-t,3); };
        var step=function(now){
          if(!is_mobile()||!$gallery_frame[0]){
            mobileSwipeHintRaf=null;
            return;
          }
          var t=Math.min(1,(now-startTime)/duration);
          $gallery_frame[0].scrollLeft=from+(to-from)*ease(t);
          if(t<1){
            mobileSwipeHintRaf=requestAnimationFrame(step);
          }else{
            mobileSwipeHintRaf=null;
            if(done) done();
          }
        };
        mobileSwipeHintRaf=requestAnimationFrame(step);
      };
        var runMobileSwipeHint=function(){
        if(!is_mobile()||len<=1||$gallery.data('ssMobileSwipeHintDone')||!$gallery_frame[0]) return;
        $gallery.data('ssMobileSwipeHintDone',true);
        stopMobileSwipeHint();
        mobileSwipeHintTimer=setTimeout(function(){
          if(!is_mobile()||!$gallery_frame[0]) return;
          stopNativeScrollTimer();
          stopMobileInertia();
          clearTimeout(slideInterval);
          var frame=$gallery_frame[0];
          var w=gallery_w();
          if(!w) return;
          var start=frame.scrollLeft||w*index;
          if(start<1){
            start=w*index;
            frame.scrollLeft=start;
          }
          var nudge=Math.min(84,Math.max(42,w*0.16));
          var oldSnap=frame.style.getPropertyValue('scroll-snap-type');
          var oldSnapPriority=frame.style.getPropertyPriority('scroll-snap-type');
          var oldBehavior=frame.style.getPropertyValue('scroll-behavior');
          frame.style.setProperty('scroll-snap-type','none','important');
          frame.style.setProperty('scroll-behavior','auto','important');
          animateMobileFrameScroll(start,start+nudge,260,function(){
            mobileSwipeHintTimer=setTimeout(function(){
              if(!is_mobile()||!$gallery_frame[0]) return;
              animateMobileFrameScroll(start+nudge,start,360,function(){
                if(oldSnap){
                  frame.style.setProperty('scroll-snap-type',oldSnap,oldSnapPriority);
                }else{
                  frame.style.setProperty('scroll-snap-type','x mandatory','important');
                }
                if(oldBehavior){
                  frame.style.setProperty('scroll-behavior',oldBehavior);
                }else{
                  frame.style.removeProperty('scroll-behavior');
                }
                frame.scrollLeft=start;
                updateNativeMobileIndex();
              });
            },120);
          });
        },900);
      };
      var mobileInertia={
        active:false,
        dragging:false,
        mode:null,
        startX:0,
        startY:0,
        lastX:0,
        lastTime:0,
        startLeft:0,
        currentX:0,
        velocity:0,
        raf:null,
        pointer:false
      };
      var getTranslateX=function(){
        var transform=$gallery_move.css('transform');
        if(!transform||transform==='none') return -(gallery_w()*index);
        try{
          return Math.floor(new WebKitCSSMatrix(transform).e);
        }catch(e){
          var m=transform.match(/matrix\(([^)]+)\)/);
          if(m){
            var values=m[1].split(',');
            return Math.floor(parseFloat(values[4])||0);
          }
        }
        return -(gallery_w()*index);
      };
      var normalizeMobileInertiaX=function(x){
        if(!len||len<=1) return x;
        var unit=gallery_w()*len;
        if(!unit) return x;
        var w=gallery_w();
        var minX=-(w*mobileLoopSafeMax());
        var maxX=-(w*mobileLoopSafeMin());
        while(x>maxX){ x-=unit; }
        while(x<=minX){ x+=unit; }
        return x;
      };
      var setMobileInertiaX=function(x){
        mobileInertia.currentX=normalizeMobileInertiaX(x);
        var w=gallery_w();
        if(is_mobile()&&$gallery_frame[0]){
          var left=Math.abs(mobileInertia.currentX);
          $gallery_frame[0].scrollLeft=left;
          $gallery_move.css({ transition:'none', transitionTimingFunction:'none', transform:'none' });
        }else{
          $gallery_move.css({ transition:'none', transitionTimingFunction:'none', transform:'translate3d('+mobileInertia.currentX+'px,0,0)' });
        }
        if(w){
          var raw=Math.round(Math.abs(mobileInertia.currentX)/w)%len;
          index=mobileLoopBase()+raw;
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
        }
      };
      var stopMobileInertia=function(){
        if(mobileInertia.raf){
          cancelAnimationFrame(mobileInertia.raf);
          mobileInertia.raf=null;
        }
      };
      var lockMobileInertiaToNearest=function(){
        if(!is_mobile()||len<=1) return;
        stopMobileInertia();
        var x=mobileInertia.currentX||getTranslateX();
        var target=getMobileNearestSnapX(x);
        setMobileInertiaX(target);
      };
      var nativeScrollTimer=null;
      var updateNativeMobileIndex=function(){
        if(!is_mobile()||len<=1||!$gallery_frame[0]) return;
        var w=gallery_w();
        if(!w) return;
        var raw=Math.round($gallery_frame[0].scrollLeft/w);
        if(raw<mobileLoopSafeMin()||raw>=mobileLoopSafeMax()){
          raw=mobileLoopCenterIndex(raw);
          $gallery_frame[0].scrollLeft=raw*w;
        }
        index=raw;
        mobileInertia.currentX=-(w*index);
        $gallery_item.removeClass('active');
        $gallery_item.eq(index).addClass('active');
      };
      var stopNativeScrollTimer=function(){
        if(nativeScrollTimer){
          clearTimeout(nativeScrollTimer);
          nativeScrollTimer=null;
        }
      };
      var getMobileNearestSnapX=function(startX){
        var w=gallery_w();
        if(!w||!len) return startX;
        var unit=w*len;
        var current=normalizeMobileInertiaX(startX);
        var base=unit*mobileLoopBuffer;
        var nearest=-base;
        var nearestDiff=Math.abs(current-nearest);
        for(var i=0;i<len;i++){
          var candidate=-(base+(w*i));
          var diff=Math.abs(current-candidate);
          if(diff<nearestDiff){
            nearest=candidate;
            nearestDiff=diff;
          }
        }
        return nearest;
      };
      var snapMobileInertia=function(){
        if(!is_mobile()||len<=1) return;
        stopMobileInertia();
        var w=gallery_w();
        if(!w) return;
        var startX=normalizeMobileInertiaX(mobileInertia.currentX);
        var targetX=getMobileNearestSnapX(startX);
        var duration=340;
        var startTime=performance.now();
        var ease=function(t){ return 1-Math.pow(1-t,3); };
        var step=function(now){
          if(!is_mobile()){
            stopMobileInertia();
            return;
          }
          var t=Math.min(1,(now-startTime)/duration);
          setMobileInertiaX(startX+(targetX-startX)*ease(t));
          if(t<1){
            mobileInertia.raf=requestAnimationFrame(step);
          }else{
            mobileInertia.raf=null;
            setMobileInertiaX(targetX);
          }
        };
        mobileInertia.raf=requestAnimationFrame(step);
      };
      var startMobileInertia=function(){
        stopMobileInertia();
        var v=mobileInertia.velocity;
        var last=performance.now();
        var step=function(now){
          if(!is_mobile()){
            stopMobileInertia();
            return;
          }
          var dt=Math.min(32,now-last);
          last=now;
          setMobileInertiaX(mobileInertia.currentX+(v*dt));
          v*=Math.pow(0.945,dt/16.67);
          if(Math.abs(v)>0.012){
            mobileInertia.raf=requestAnimationFrame(step);
          }else{
            mobileInertia.raf=null;
            snapMobileInertia();
          }
        };
        if(Math.abs(v)>0.012){
          mobileInertia.raf=requestAnimationFrame(step);
        }else{
          snapMobileInertia();
        }
      };
      var startHorizontalDrag=function(pageX,pageY,isPointer){
        if(!is_mobile()||len<=1) return;
        touch.bool=true;
        touch.dragging=false;
        touch.mode=null;
        touch.pointer=!!isPointer;
        touch.X=pageX;
        touch.Y=pageY;
        touch.pos=pageX;
        mobileInertia.active=true;
        mobileInertia.dragging=false;
        mobileInertia.mode=null;
        mobileInertia.startX=pageX;
        mobileInertia.startY=pageY;
        mobileInertia.lastX=pageX;
        mobileInertia.lastTime=performance.now();
        mobileInertia.startLeft=getTranslateX();
        stopMobileInertia();
        $gallery_move.css({ transitionTimingFunction:'none',transition:'none' });
        clearTimeout(slideInterval);
        mobileInertia.startLeft=getTranslateX();
        mobileInertia.currentX=mobileInertia.startLeft;
        mobileInertia.velocity=0;
        mobileInertia.pointer=!!isPointer;
      };
      var moveHorizontalDrag=function(pageX,pageY,originalEvent){
        if(!mobileInertia.active||!is_mobile()) return;
        var dx=pageX-mobileInertia.startX;
        var dy=pageY-mobileInertia.startY;
        var adx=Math.abs(dx);
        var ady=Math.abs(dy);
        if(mobileInertia.mode==='vertical') return;
        if(!mobileInertia.mode){
          if(ady>4&&ady>adx*1.1){
            mobileInertia.mode='vertical';
            mobileInertia.dragging=false;
            mobileInertia.active=false;
            mobileInertia.velocity=0;
            touch.bool=false;
            touch.dragging=false;
            touch.mode='vertical';
            stopMobileInertia();
            $gallery_move.css({ transitionTimingFunction:'none',transition:'none' });
            return;
          }
          if(adx>32&&adx>ady*5.5){
            mobileInertia.mode='horizontal';
            mobileInertia.dragging=true;
            touch.mode='horizontal';
            touch.dragging=true;
            stopMobileInertia();
            clearTimeout(slideInterval);
            mobileInertia.startX=pageX;
            mobileInertia.startY=pageY;
            mobileInertia.lastX=pageX;
            mobileInertia.lastTime=performance.now();
            mobileInertia.startLeft=getTranslateX();
            mobileInertia.currentX=mobileInertia.startLeft;
            $gallery_move.css({ transitionTimingFunction:'none',transition:'none' });
            return;
          }
          return;
        }
        if(mobileInertia.mode!=='horizontal') return;
        if(originalEvent&&originalEvent.cancelable) originalEvent.preventDefault();
        dx=pageX-mobileInertia.startX;
        var now=performance.now();
        var dt=Math.max(8,now-mobileInertia.lastTime);
        mobileInertia.velocity=((pageX-mobileInertia.lastX)/dt)*1.12;
        mobileInertia.lastX=pageX;
        mobileInertia.lastTime=now;
        touch.pos=Math.floor(pageX);
        setMobileInertiaX(mobileInertia.startLeft+dx);
      };
      var endHorizontalDrag=function(){
        if(!mobileInertia.active||!is_mobile()){
          touch.bool=false;
          mobileInertia.active=false;
          return;
        }
        if(mobileInertia.mode==='horizontal'&&mobileInertia.dragging){
          startMobileInertia();
        }
        touch.bool=false;
        touch.dragging=false;
        touch.mode=null;
        mobileInertia.active=false;
        mobileInertia.dragging=false;
        mobileInertia.mode=null;
      };
      var bindMobileSwipe=function(){
        var settingJsDesktopLikeMobile=function(){
          return is_mobile()&&!(('ontouchstart' in window)||((navigator&&navigator.maxTouchPoints)||0)>0);
        };
        if(window.__SS_DISABLE_SETTING_JS_MAC_MOBILE_GALLERY__&&settingJsDesktopLikeMobile()){
          return;
        };
        $gallery_move.off('touchstart.ssProductSwipe touchmove.ssProductSwipe touchend.ssProductSwipe touchcancel.ssProductSwipe mousedown.ssProductSwipe mousemove.ssProductSwipe mouseup.ssProductSwipe mouseleave.ssProductSwipe');
        $gallery_frame.off('touchstart.ssProductInertia touchmove.ssProductInertia touchend.ssProductInertia touchcancel.ssProductInertia mousedown.ssProductInertia mouseleave.ssProductInertia dragstart.ssProductInertia wheel.ssProductInertia scroll.ssProductNativeSnap');
        $(document).off('mousemove.ssProductSwipe mouseup.ssProductSwipe mousemove.ssProductInertia mouseup.ssProductInertia');

        var desktopLikeMobile=function(){
          return is_mobile()&&!(('ontouchstart' in window)||((navigator&&navigator.maxTouchPoints)||0)>0);
        };

        var snapBackup=null;
        var animRaf=null;
        var wheelAccum=0;
        var wheelLastTs=0;
        var wheelLockUntil=0;
        var currentLoopIndex=0;

        var stopAnim=function(){
          if(animRaf){
            cancelAnimationFrame(animRaf);
            animRaf=null;
          }
        };

        var setSnap=function(enabled){
          if(!$gallery_frame[0]) return;
          if(!enabled){
            snapBackup={
              snap:$gallery_frame[0].style.getPropertyValue('scroll-snap-type'),
              snapPriority:$gallery_frame[0].style.getPropertyPriority('scroll-snap-type'),
              behavior:$gallery_frame[0].style.getPropertyValue('scroll-behavior'),
              behaviorPriority:$gallery_frame[0].style.getPropertyPriority('scroll-behavior')
            };
            $gallery_frame[0].style.setProperty('scroll-snap-type','none','important');
            $gallery_frame[0].style.setProperty('scroll-behavior','auto','important');
          }else{
            if(snapBackup&&snapBackup.snap){
              $gallery_frame[0].style.setProperty('scroll-snap-type',snapBackup.snap,snapBackup.snapPriority||'');
            }else{
              $gallery_frame[0].style.removeProperty('scroll-snap-type');
            }
            if(snapBackup&&snapBackup.behavior){
              $gallery_frame[0].style.setProperty('scroll-behavior',snapBackup.behavior,snapBackup.behaviorPriority||'');
            }else{
              $gallery_frame[0].style.removeProperty('scroll-behavior');
            }
            snapBackup=null;
          }
        };

        var middleIndexFromLoop=function(loopIndex){
          return len+(((loopIndex%len)+len)%len);
        };

        var updateDesktopStateFromFrame=function(){
          if(!$gallery_frame[0]||!len) return;
          var w=gallery_w();
          if(!w) return;
          var raw=Math.round($gallery_frame[0].scrollLeft/w);
          if(raw<len){
            raw+=len;
          }else if(raw>=len*2){
            raw-=len;
          }
          currentLoopIndex=((raw-len)%len+len)%len;
          index=raw;
          mobileInertia.currentX=-(w*index);
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
        };

        var forceDesktopIndex=function(loopIndex){
          if(!$gallery_frame[0]||!len) return;
          var w=gallery_w();
          if(!w) return;
          currentLoopIndex=((loopIndex%len)+len)%len;
          index=middleIndexFromLoop(currentLoopIndex);
          $gallery_frame[0].scrollLeft=index*w;
          mobileInertia.currentX=-(w*index);
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
        };

        var animateDesktopTo=function(nextLoopIndex,duration){
          if(!$gallery_frame[0]||!len) return;
          stopAnim();
          var frame=$gallery_frame[0];
          var w=gallery_w();
          if(!w) return;
          var targetIndex=middleIndexFromLoop(nextLoopIndex);
          var startLeft=frame.scrollLeft;
          var targetLeft=targetIndex*w;
          var startTime=performance.now();
          setSnap(false);
          var ease=function(t){ return 1-Math.pow(1-t,3); };
          animRaf=requestAnimationFrame(function step(now){
            if(!desktopLikeMobile()||!frame){
              animRaf=null;
              setSnap(true);
              return;
            }
            var t=Math.min(1,(now-startTime)/duration);
            frame.scrollLeft=startLeft+(targetLeft-startLeft)*ease(t);
            if(t<1){
              animRaf=requestAnimationFrame(step);
            }else{
              animRaf=null;
              forceDesktopIndex(nextLoopIndex);
              setSnap(true);
            }
          });
        };

        var desktopStep=function(delta){
          if(!desktopLikeMobile()||!len||!delta) return;
          var now=Date.now();
          if(now<wheelLockUntil) return;
          wheelLockUntil=now+420;
          animateDesktopTo(currentLoopIndex+delta,180);
        };

        var updateNativeMobileIndex=function(){
          if(!is_mobile()||len<=1||!$gallery_frame[0]) return;
          if(desktopLikeMobile()){
            updateDesktopStateFromFrame();
            return;
          }
          var w=gallery_w();
          if(!w) return;
          var raw=Math.round($gallery_frame[0].scrollLeft/w);
          if(raw<mobileLoopSafeMin()||raw>=mobileLoopSafeMax()){
            raw=mobileLoopCenterIndex(raw);
            $gallery_frame[0].scrollLeft=raw*w;
          }
          index=raw;
          mobileInertia.currentX=-(w*index);
          $gallery_item.removeClass('active');
          $gallery_item.eq(index).addClass('active');
        };

        $gallery_frame.on('scroll.ssProductNativeSnap',function(){
          if(!is_mobile()||len<=1) return;
          if(desktopLikeMobile()) return;
          stopNativeScrollTimer();
          nativeScrollTimer=setTimeout(function(){
            updateNativeMobileIndex();
          },110);
        });

        $gallery_frame.on('wheel.ssProductInertia',function(event){
          if(!desktopLikeMobile()||len<=1||!$gallery_frame[0]) return;
          var oe=event.originalEvent;
          var dx=oe.deltaX||0;
          var dy=oe.deltaY||0;
          if(Math.abs(dx)<=Math.max(2,Math.abs(dy)*1.01)) return;
          if(oe.cancelable) oe.preventDefault();
          if(typeof oe.stopPropagation==='function') oe.stopPropagation();
          stopMobileInertia();
          stopNativeScrollTimer();
          stopMobileSwipeHint();
          clearTimeout(slideInterval);

          var now=Date.now();
          if(now-wheelLastTs>120){
            wheelAccum=0;
          }
          wheelLastTs=now;

          if(now<wheelLockUntil) return;

          if((wheelAccum>0&&dx<0)||(wheelAccum<0&&dx>0)){
            wheelAccum=0;
          }
          wheelAccum+=dx;

          if(Math.abs(wheelAccum)>=6){
            var delta=wheelAccum>0?1:-1;
            wheelAccum=0;
            desktopStep(delta);
          }
        });

        $gallery_frame.on('dragstart.ssProductInertia',function(event){
          if(desktopLikeMobile()) event.preventDefault();
        });
        $gallery_frame.on('mousedown.ssProductInertia',function(event){
          if(desktopLikeMobile()) return;
        });
        $(document).on('mousemove.ssProductInertia',function(){});
        $(document).on('mouseup.ssProductInertia',function(){});

        if(desktopLikeMobile()){
          setTimeout(function(){
            updateDesktopStateFromFrame();
            forceDesktopIndex(currentLoopIndex);
          },0);
        }
      };
      var start=function(){
        initialize();
        if(first){
          first=false;
          if(len>1){
            for(var c=0;c<mobileLoopBuffer;c++){
              for(var i=0;i<len;i++){
                $gallery_move.append($gallery_item.eq(i).clone(true));
                $gallery_move.prepend($gallery_item.eq((len-1)-i).clone(true));
              };
            };
            $gallery_item=$gallery_move.find('.'+op.prefix+'-gallery--item');
            len2=$gallery_item.length;
            $gallery_item.eq(index).addClass('active');
            thumbControl();
            setTimeout(function(){
              $gallery.animate({ opacity:1 },400);
              $content.animate({ opacity:1 },400);
              resetSlide();
            },200);
            bindMobileSwipe();
            runMobileSwipeHint();
          }else{
            index=0;
            $gallery_item.eq(index).addClass('active');
            setTimeout(function(){
              $gallery.animate({ opacity:1 },400);
              $content.animate({ opacity:1 },400);
              resetSlide();
            },200);
          };
          for(var i=0;i<len;i++){
            $gallery_item.eq(i).addClass('origin');
          };
        };
      };

      start();

// more detail：安定版（モバイルは通常overlay、デスクトップはinline）
function ssResetMoreDetailState(){
  $('body').removeClass('body-description-open body-description-inline-open ss-product-detail-shifted body-description-closing body-description-text-closing');
  $('.product-detail-description').removeClass('is-inline-open');
  $('html,body').css({overflow:'',position:'',top:'',left:'',right:'',width:'',height:'',touchAction:''});
}

$description_btn.off('click.moredetail').on('click.moredetail', function(e){
  e.preventDefault();

  var isDesktopMedia = window.matchMedia('(min-width: 750px)').matches;
  if (isDesktopMedia) {
    var $body = $('body');
    var $descWrap = $(this).closest('.product-detail-description');
    var willOpen = !$descWrap.hasClass('is-inline-open');
    $('.product-detail-description').removeClass('is-inline-open');
    $body.removeClass('body-description-open body-description-inline-open ss-product-detail-shifted body-description-closing body-description-text-closing');
    $('html,body').css({overflow:'',position:'',top:'',left:'',right:'',width:'',height:'',touchAction:''});
    if (willOpen) {
      $descWrap.addClass('is-inline-open');
      $body.addClass('body-description-inline-open');
    }
    return false;
  }

  // Mobile overlay behaviour (749px and below)
  $description_target.stop(true, true).show();
  $('body').removeClass('body-description-inline-open ss-product-detail-shifted body-description-closing body-description-text-closing').addClass('body-description-open');
  $('.product-detail-description').removeClass('is-inline-open');

  // more detailを開いた時は、商品ページ本体のスクロール位置は触らず、
  // パネル内だけを必ず先頭へ戻す。
  // どの位置から開いても見出しから表示させるための処理。
  function ssResetMoreDetailScroll(){
    var panel = $description_target.get(0);
    var frame = $description_target.find('.product__description__frame').get(0);
    if(panel) panel.scrollTop = 0;
    if(frame) frame.scrollTop = 0;
  }
  ssResetMoreDetailScroll();
  window.requestAnimationFrame(ssResetMoreDetailScroll);
  window.setTimeout(ssResetMoreDetailScroll, 80);

  return false;
});

$description_close.off('click.moredetail').on('click.moredetail', function(e){
  e.preventDefault();
  var isMobileMedia = window.matchMedia('(max-width: 749px)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(isMobileMedia && $('body').hasClass('body-description-open') && !reduceMotion){
    if($('body').hasClass('body-description-text-closing')) return false;
    $('body').addClass('body-description-text-closing');
    setTimeout(function(){
      ssResetMoreDetailState();
      $description_target.stop(true, true).hide();
      setTimeout(ssResetMoreDetailState,80);
    },560);
    return false;
  }
  ssResetMoreDetailState();
  $description_target.stop(true, true).hide();
  setTimeout(ssResetMoreDetailState,80);
  setTimeout(ssResetMoreDetailState,360);
  return false;
});

    // Enable scroll with wheel and drag only on the sticky info column when inline description is open (desktop)
  (function enableInlineScroll(){
    var $scrollContainer = $('.product-detail-content .product__column-sticky');
    // Bind only once per page
    if ($scrollContainer.length && !$scrollContainer.data('inlineScrollBound')) {
      $scrollContainer.data('inlineScrollBound', true);
      // wheel scroll inside container on desktop
      $scrollContainer.on('wheel.inlineScroll', function(e){
        // Only enable custom scroll behaviour for desktop widths (750px+)
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        // more detail をデスクトップ inline 表示している時は、
        // 左側テキスト上のホイールは左側テキストだけをスクロールする。
        // 右側画像上のホイールは product-media-vertical-inertia.js 側で画像だけを動かす。
        if ($('body').hasClass('body-description-inline-open')) {
          if (this.scrollHeight <= this.clientHeight) return;
          e.preventDefault();
          e.stopPropagation();
          this.scrollTop += e.originalEvent.deltaY;
          return;
        }
        // 通常時は、内部スクロールがある場合だけ左カラムをスクロールする。
        if (this.scrollHeight <= this.clientHeight) return;
        e.preventDefault();
        this.scrollTop += e.originalEvent.deltaY;
      });
      // drag scroll on desktop
      var isDown = false;
      var startY, scrollTop;
      $scrollContainer.on('mousedown.inlineScroll', function(e){
        // Only enable drag scroll on desktop widths
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        // Left click only
        if (e.button !== 0) return;
        // Do not start dragging when clicking on interactive elements (links, buttons, form fields, etc.)
        if ($(e.target).closest('a, button, input, textarea, select, label, [contenteditable="true"]').length) {
          return;
        }
        // 内部スクロールが無い（= もう切れて見えない）ならドラッグ開始しない
        if (this.scrollHeight <= this.clientHeight) return;
        isDown = true;
        startY = e.pageY;
        scrollTop = this.scrollTop;
        $(this).addClass('is-dragging');
        e.preventDefault();
      });
      $(window).on('mousemove.inlineScroll', function(e){
        if (!isDown) return;
        var dy = e.pageY - startY;
        $scrollContainer.each(function(){
          this.scrollTop = scrollTop - dy;
        });
      });
      $(window).on('mouseup.inlineScroll', function(){
        if (isDown) {
          isDown = false;
          $scrollContainer.removeClass('is-dragging');
        }
      });
    }
  })();

// 左→右スワイプで「more detail」パネルを閉じる
(function(){
  if (!('ontouchstart' in window)) return; // タッチ端末のみ

  var startX = 0, startY = 0;
  var THRESHOLD = 70;   // どれだけ横に動いたら判定するか（px）
  var HORIZ_K   = 1.2;  // 横移動が縦移動の何倍以上ならOKか

  // 目印を付けたパネル（= .product__description）でのみ判定
  $description_target.on('touchstart', function(e){
    // 入力フィールド等を触っている最中は無視
    if ($(e.target).closest('input, textarea, select, button, [contenteditable="true"]').length) return;

    var t = e.originalEvent.touches[0];
    startX = t.clientX;
    startY = t.clientY;
  });

  $description_target.on('touchend', function(e){
    var t = e.originalEvent.changedTouches[0];
    var dx = t.clientX - startX;   // 右に動くとプラス（=左→右）
    var dy = t.clientY - startY;

    // 左→右のみ / 水平優勢 / しきい値超え
    if (dx > THRESHOLD && dx > Math.abs(dy) * HORIZ_K) {
      $description_close.trigger('click'); // 既存の閉じる処理を呼ぶ
      e.preventDefault();
    }
  });
})();
      var productDetailResizeTimer=null;
      var ssForceCloseMoreDetailOnFinePointerResize=function(){
        if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        if(!$('body').hasClass('body-description-open')&&!$('body').hasClass('body-description-inline-open')&&!$('body').hasClass('body-description-text-closing')) return;
        ssResetMoreDetailState();
        $description_target.stop(true,true).hide();
        $('.product-detail-description').removeClass('is-inline-open');
        setTimeout(ssResetMoreDetailState,80);
      };
      $(window).on({
        'resize':function(){
          clearTimeout(productDetailResizeTimer);
          ssForceCloseMoreDetailOnFinePointerResize();
          stopMobileInertia();
          $gallery_move.css({ transitionTimingFunction:'none',transition:'none' });
          productDetailResizeTimer=setTimeout(function(){ initialize(); },120);
        }
      });
    }
  });

  if($('select.is-link').length) $('select.is-link').each(function(){ $(this).selectLink(); });
  if($('.announcement-block').length) $('.announcement-block').announcementBlock();
  if($('.header-wrapper').length) $('.header-wrapper').header();
  if($('.section-visual').length) $('.section-visual').styleDissolve({ prefix:'section-visual' });
  if($('.collection-dissolve').length) $('.collection-dissolve').styleDissolve({ prefix:'collection-dissolve' });
  if($('.product-detail').length) $('.product-detail').productDetail();

if (false && $('.slide-1').length) {
    $('.slide-1').each(function(){
      if(!$(this).hasClass('slide-started')){
        var base={
          mobile:$(this).data('slide-mobile-base'),
          desktop:$(this).data('slide-desktop-base')
        };
        var margin={
          mobile:$(this).data('slide-mobile-margin'),
          desktop:$(this).data('slide-desktop-margin')
        };
        var w={
          mobile:$(this).data('slide-mobile-w'),
          desktop:$(this).data('slide-desktop-w')
        };
        var space={
          mobile:$(this).data('slide-mobile-space'),
          desktop:$(this).data('slide-desktop-space')
        };
        var interval=$(this).data('slide-interval');
        var scroll=$(this).data('slide-scroll');
        $(this).addClass('slide-started');
        $(this).styleSlide({
          base:base,
          margin:margin,
          w:w,
          space:space,
          interval:interval,
          scroll
        });
      };
    });
  };

  $('body').winSizeSet({
    set:function($t){
      if(is_mobile()){
        $t.addClass('device-mobile').removeClass('device-desktop');
      }else{
        $t.removeClass('device-mobile').addClass('device-desktop');
      };
    }
  });

  if(is_touch()){
    $('body').addClass('device-touch');
  }else{
    $('body').addClass('device-click');
  };

  function ssSetIpadDrawerDevice(){
    var ua = navigator.userAgent || '';
    var hasTouch = !!(navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
    var isIpad = /iPad/.test(ua) || (/Macintosh/.test(ua) && hasTouch);
    document.documentElement.classList.toggle('ss-ipad-drawer-device', isIpad);
    document.body.classList.toggle('ss-ipad-drawer-device', isIpad);
  }
  ssSetIpadDrawerDevice();

});

(function(){
function removeProductDetailGalleryThumb(){
if(!document.documentElement || document.documentElement.getAttribute('data-template') !== 'product') return;
document.querySelectorAll('.product-detail-gallery__thumb').forEach(function(el){
el.remove();
});
}
if(document.readyState === 'loading'){
document.addEventListener('DOMContentLoaded', removeProductDetailGalleryThumb);
}else{
removeProductDetailGalleryThumb();
}
window.addEventListener('load', removeProductDetailGalleryThumb);
window.addEventListener('resize', removeProductDetailGalleryThumb);
setTimeout(removeProductDetailGalleryThumb, 100);
setTimeout(removeProductDetailGalleryThumb, 500);
setTimeout(removeProductDetailGalleryThumb, 1500);
try{
var observer = new MutationObserver(removeProductDetailGalleryThumb);
observer.observe(document.documentElement, { childList: true, subtree: true });
}catch(e){}
})();


(function(){
function ready(fn){
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
else fn();
}
ready(function(){
var root=document.documentElement;
var details=document.getElementById('Details-menu-drawer-container');
var drawer=document.getElementById('menu-drawer');
if(!root||!details||!drawer) return;
var toggler=details.querySelector('summary');
var tracking=false;
var dragging=false;
var mode=null;
var startX=0;
var startY=0;
var lastX=0;
var lastY=0;
var drawerWidth=0;
var edgeSize=56;
var threshold=12;
var snapTime=220;
function isIpadDrawer(){
return root.classList.contains('ss-ipad-drawer-device')&&window.matchMedia('(min-width:750px)').matches;
}
function isOpen(){
return details.hasAttribute('open');
}
function openDrawerForDrag(){
if(isOpen()) return;
if(toggler){
try{toggler.click();}catch(e){details.setAttribute('open','');}
}else{
details.setAttribute('open','');
}
root.style.setProperty('--ipad-drawer-offset','100%');
}
function closeDrawerAfterDrag(){
if(typeof window.cbCloseSpDrawer==='function'){
window.cbCloseSpDrawer();
}else{
details.classList.remove('menu-opening');
details.removeAttribute('open');
root.removeAttribute('data-menu-open');
root.classList.remove('cb-menu-open');
if(document.body) document.body.classList.remove('cb-menu-open');
}
root.style.removeProperty('--ipad-drawer-offset');
root.removeAttribute('data-ipad-menu-dragging');
}
function begin(x,y,target){
if(!isIpadDrawer()) return;
if(document.body&&document.body.classList.contains('body-description-open')) return;
var open=isOpen();
if(open){
if(target&&toggler&&toggler.contains(target)) return;
if(target&&!drawer.contains(target)&&!target.closest('.cb-menu-screen')) return;
mode='close';
}else{
if(x < window.innerWidth - edgeSize) return;
if(target&&(target.closest('a,button,input,textarea,select,label,.swiper,.product-detail-gallery,.product-detail-overlay,.mobile-facets,.mobile-facets__wrapper,.mobile-facets__inner,.mobile-facets__main'))) return;
mode='open';
}
tracking=true;
dragging=false;
startX=x;
startY=y;
lastX=x;
lastY=y;
drawerWidth=drawer.getBoundingClientRect().width||Math.min(440,window.innerWidth*.62)||window.innerWidth;
}
function startDrag(){
if(dragging) return;
dragging=true;
root.setAttribute('data-ipad-menu-dragging','true');
if(mode==='open') openDrawerForDrag();
}
function move(x,y){
if(!tracking) return false;
lastX=x;
lastY=y;
var dx=lastX-startX;
var dy=lastY-startY;
if(!dragging){
var absX=Math.abs(dx);
var absY=Math.abs(dy);
if(absX<threshold) return false;
if(absX<absY){tracking=false;return false;}
if(mode==='close'&&dx<=0){tracking=false;return false;}
if(mode==='open'&&dx>=0){tracking=false;return false;}
startDrag();
}
if(mode==='close'){
var closeDx=Math.max(0,lastX-startX);
var progress=drawerWidth?Math.min(closeDx/drawerWidth,1):0;
root.style.setProperty('--ipad-drawer-offset',(progress*100).toFixed(3)+'%');
}else{
var openDx=Math.max(0,startX-lastX);
var progress=drawerWidth?Math.min(openDx/drawerWidth,1):0;
root.style.setProperty('--ipad-drawer-offset',(100-progress*100).toFixed(3)+'%');
}
return true;
}
function end(){
if(!tracking) return;
tracking=false;
if(!dragging) return;
dragging=false;
root.removeAttribute('data-ipad-menu-dragging');
var dx=lastX-startX;
if(mode==='close'){
var progress=drawerWidth?Math.min(Math.max(0,dx)/drawerWidth,1):0;
if(progress>0.32){
root.style.setProperty('--ipad-drawer-offset','100%');
setTimeout(closeDrawerAfterDrag,snapTime);
}else{
root.style.setProperty('--ipad-drawer-offset','0%');
setTimeout(function(){root.style.removeProperty('--ipad-drawer-offset');},snapTime);
}
}else if(mode==='open'){
var progress=drawerWidth?Math.min(Math.max(0,-dx)/drawerWidth,1):0;
if(progress>0.18){
root.style.setProperty('--ipad-drawer-offset','0%');
setTimeout(function(){root.style.removeProperty('--ipad-drawer-offset');},snapTime);
}else{
root.style.setProperty('--ipad-drawer-offset','100%');
setTimeout(closeDrawerAfterDrag,snapTime);
}
}
mode=null;
}
function onStart(e){
if(!e.touches||e.touches.length!==1) return;
var t=e.touches[0];
begin(t.clientX,t.clientY,e.target);
}
function onMove(e){
if(!tracking||!e.touches||e.touches.length!==1) return;
var t=e.touches[0];
if(move(t.clientX,t.clientY)) e.preventDefault();
}
document.addEventListener('touchstart',onStart,{passive:true,capture:true});
document.addEventListener('touchmove',onMove,{passive:false,capture:true});
document.addEventListener('touchend',end,{passive:true,capture:true});
document.addEventListener('touchcancel',end,{passive:true,capture:true});
});
})();

/* =========================================================
   Drawer close alignment v5
   Align visible close X right edge to visible search arrow right edge
   iPhone / iPad / Mac mobile drawer
   ========================================================= */
(function(){
  function alignDrawerCloseToSearchArrow(){
    var drawer=document.getElementById('menu-drawer');
    if(!drawer) return;
    var close=drawer.querySelector('.gnav-close');
    var arrow=drawer.querySelector('.gnav-search .search__button svg')||drawer.querySelector('.gnav-search .search__button');
    if(!close||!arrow) return;
    var parent=close.offsetParent||drawer;
    var parentRect=parent.getBoundingClientRect();
    var arrowRect=arrow.getBoundingClientRect();
    if(!parentRect.width||!arrowRect.width) return;
    var right=Math.max(0,parentRect.right-arrowRect.right);
    close.style.setProperty('right',right+'px','important');
  }
  function requestAlign(){
    window.requestAnimationFrame(function(){
      alignDrawerCloseToSearchArrow();
      window.setTimeout(alignDrawerCloseToSearchArrow,80);
      window.setTimeout(alignDrawerCloseToSearchArrow,260);
    });
  }
  document.addEventListener('DOMContentLoaded',requestAlign);
  window.addEventListener('load',requestAlign,{passive:true});
  window.addEventListener('resize',requestAlign,{passive:true});
  document.addEventListener('click',function(e){
    if(e.target&&e.target.closest&&e.target.closest('header-drawer')) requestAlign();
  },true);
  document.addEventListener('toggle',function(e){
    if(e.target&&e.target.matches&&e.target.matches('#Details-menu-drawer-container')) requestAlign();
  },true);
  document.addEventListener('touchend',function(e){
    if(e.target&&e.target.closest&&e.target.closest('header-drawer')) requestAlign();
  },{passive:true,capture:true});
})();

/* SS 2026-06-02: drawer icon timing v1 */
(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function(){
    var root = document.documentElement;
    var details = document.getElementById('Details-menu-drawer-container');
    var drawer = document.getElementById('menu-drawer');
    if(!root || !details) return;
    var summary = details.querySelector('summary');
    var timer = null;
    var duration = 460;
    function setIconState(state){
      root.setAttribute('data-ss-drawer-icon-state', state);
      if(timer) window.clearTimeout(timer);
      timer = window.setTimeout(function(){
        root.removeAttribute('data-ss-drawer-icon-state');
        timer = null;
      }, duration);
    }
    if(summary){
      summary.addEventListener('click', function(){
        setIconState(details.hasAttribute('open') ? 'closing' : 'opening');
      }, true);
    }
    function setClosingNow(){
      setIconState('closing');
      root.classList.add('ss-burger-return-now');
      window.setTimeout(function(){
        root.classList.remove('ss-burger-return-now');
      }, 220);
    }
    function isCloseTarget(e){
      return e && e.target && e.target.closest && e.target.closest('.gnav-close, .gnav-close-btn, .menu-drawer__close-button, .cb-menu-screen');
    }
    if(drawer){
      drawer.addEventListener('touchstart', function(e){
        if(isCloseTarget(e)) setClosingNow();
      }, {passive:true, capture:true});
      drawer.addEventListener('pointerdown', function(e){
        if(isCloseTarget(e)) setClosingNow();
      }, true);
      drawer.addEventListener('click', function(e){
        if(isCloseTarget(e)) setClosingNow();
      }, true);
    }
    document.addEventListener('touchstart', function(e){
      if(isCloseTarget(e)) setClosingNow();
    }, {passive:true, capture:true});
    document.addEventListener('pointerdown', function(e){
      if(isCloseTarget(e)) setClosingNow();
    }, true);
    document.addEventListener('click', function(e){
      if(isCloseTarget(e)) setClosingNow();
    }, true);
    details.addEventListener('toggle', function(){
      setIconState(details.hasAttribute('open') ? 'opening' : 'closing');
    });
  });
})();
